import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
//
import AllRoutes from './routes';
//
import 'react-toastify/dist/ReactToastify.css';
import './toast-overrides.css';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        autoClose={3000}
        theme="light"
        position="top-center"
        draggable
        hideProgressBar
        closeButton={false}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
      <AllRoutes />
    </BrowserRouter>
  );
}

export default App;
